import React from 'react'
import { Outlet } from 'react-router-dom'

function MainTeamMember() {
  return (
    <div>
          <Outlet/>
        </div>
  )
}

export default MainTeamMember